// One height per size name for every form control (#1360).
//
// `Input` and `Select` take their height from here; a chip, toggle group or
// icon button that sits in the same row as them takes it from here too, so a
// row never goes ragged. Same heights as `Button` (sm 32, md 36, lg 40).
// Control height comes from the `size` variant, never from the call site
// (.claude/rules/patterns/design-system.md). Class names are spelled out in
// full so Tailwind's source scan sees them.

export type ControlSize = 'sm' | 'md' | 'lg';

export const CONTROL_HEIGHT: Record<ControlSize, string> = {
  sm: 'h-8',
  md: 'h-9',
  lg: 'h-10',
};

/** Square icon-only control (e.g. a clear button) matching the row's height. */
export const CONTROL_SQUARE: Record<ControlSize, string> = {
  sm: 'h-8 w-8',
  md: 'h-9 w-9',
  lg: 'h-10 w-10',
};

/**
 * The same heights as a floor, for a raw text control (a link, a bare button)
 * whose label is translated and may wrap: a fixed `h-*` would let a wrapped
 * label spill out of the frame, a `min-h-*` grows with it. `Button` does the
 * same (its sizes are `min-h-[32|36|40px]`).
 */
export const CONTROL_MIN_HEIGHT: Record<ControlSize, string> = {
  sm: 'min-h-8',
  md: 'min-h-9',
  lg: 'min-h-10',
};
